import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AuthProvider } from './providers/authProvider';
import CustomRoutes from './routes';
import { AppProvider } from './providers/appProvider';
import { baseFileURL } from './Api';

function App() {
  useEffect(() => {
    const link = document.querySelector('link[rel="icon"]');
    const manifest = document.querySelector('link[rel="manifest"]');
    const appleTouch = document.querySelector('link[rel="apple-touch-icon"]');
    const themeColor = document.querySelector('meta[name="theme-color"]');
    let title = '';   
    switch (baseFileURL) {
      case "https://crm.aig.com.ge":
        manifest.setAttribute('href', '/manifest-aig.json');
        link.setAttribute('href', '/favicon-aig.ico');
        appleTouch.setAttribute('href', '/logo192-aig.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'AIG CRM';
        break;
      case "https://crmdev.aig.com.ge":
        manifest.setAttribute('href', '/manifest-aig.json');
        link.setAttribute('href', '/favicon-aig.ico');
        appleTouch.setAttribute('href', '/logo192-aig.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'AIG CRM';
        break;
      case "https://crm.autonomo.kz":
        manifest.setAttribute('href', '/manifest-autonomo.json');
        link.setAttribute('href', '/favicon-autonomo.ico');
        appleTouch.setAttribute('href', '/logo192-autonomo.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'Autonomo CRM';
        break;
      case "https://finance.automoby.ge":
        manifest.setAttribute('href', '/manifest.json');
        link.setAttribute('href', '/favicon.ico');
        appleTouch.setAttribute('href', '/logo192.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'Automoby CRM';
        break;
      case "https://i-logistics.net":
        manifest.setAttribute('href', '/manifest-ilogisitcs.json');
        link.setAttribute('href', '/favicon-ilogistics.ico');
        appleTouch.setAttribute('href', '/logo192.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'Finance';
        break;
      case "https://dev.i-logistics.net":
        manifest.setAttribute('href', '/manifest-ilogisitcs.json');
        link.setAttribute('href', '/favicon-ilogistics.ico');
        appleTouch.setAttribute('href', '/logo192.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'Finance';
        break;
      default:
        manifest.setAttribute('href', '/manifest.json');
        link.setAttribute('href', '/favicon.ico');
        appleTouch.setAttribute('href', '/logo192.png');
        themeColor.setAttribute('content', '#444'); 
        title = 'Finance App';
    }
    

    document.title = title;
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();  // Hook to get current URL path

  const isCarPhotosRoute = location.pathname.startsWith('/c/');

  return (
    isCarPhotosRoute ? (

      <AppProvider>
        <CustomRoutes />
      </AppProvider>
    ) : (

      <AuthProvider>
        <AppProvider>
          <CustomRoutes />
        </AppProvider>
      </AuthProvider>
    )
  );
}

export default App;
